import { render, staticRenderFns } from "./CotacaoFreteDetalhesCardDetalhes.vue?vue&type=template&id=21797848"
import script from "./CotacaoFreteDetalhesCardDetalhes.vue?vue&type=script&lang=js"
export * from "./CotacaoFreteDetalhesCardDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports